"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ByPromoCodeAndOrganizationDto = exports.GetOrganizationPromoCodesDto = exports.UpdatePromoCodesDto = exports.CreatePromoCodesDto = exports.UpdatePromoCodeDto = exports.CreatePromoCodeDto = exports.PromoCodeDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
const EXAMPLE_CODE = 'HOLIDAY25';
class PromoCodeDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.PromoCodeDto = PromoCodeDto;
class CreatePromoCodeDto {
}
exports.CreatePromoCodeDto = CreatePromoCodeDto;
class UpdatePromoCodeDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.UpdatePromoCodeDto = UpdatePromoCodeDto;
class CreatePromoCodesDto {
}
exports.CreatePromoCodesDto = CreatePromoCodesDto;
class UpdatePromoCodesDto {
}
exports.UpdatePromoCodesDto = UpdatePromoCodesDto;
class GetOrganizationPromoCodesDto extends general_dto_1.PaginationQuery {
}
exports.GetOrganizationPromoCodesDto = GetOrganizationPromoCodesDto;
class ByPromoCodeAndOrganizationDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByPromoCodeAndOrganizationDto = ByPromoCodeAndOrganizationDto;
//# sourceMappingURL=promo-code.dto.js.map